/* ============================================================================
   PADAM MODULE — bahagian bahaya di hujung modal Module Settings (admin) · 17 Okt 2026
   ============================================================================
   Logik + pagar: services/padamModuleService.js (module asas / dibuka kepada pelanggan → tidak boleh).
   Pengesahan: admin MENAIP id module sebelum butang merah hidup (satu klik silap tidak cukup).
   Gagal = mesej merah dalam modal (bukan senyap). Admin UI = English (gaya modal sedia ada: inline style).
   ========================================================================== */
import { useState } from 'react';
import { sebabTakBolehPadam } from '../services/padamModuleService';

export default function PadamModuleSeksyen({ moduleId, moduleLabel, regModule, onPadam }) {
    const [buka, setBuka] = useState(false);
    const [taip, setTaip] = useState('');
    const [sedang, setSedang] = useState(false);
    const [ralat, setRalat] = useState('');
    const sebab = sebabTakBolehPadam(moduleId, regModule);
    const padan = taip.trim() === moduleId;

    const jalan = async () => {
        if (!padan || sedang) return;
        setSedang(true);
        setRalat('');
        try {
            await onPadam?.();
        } catch (e) {
            setRalat('Delete failed: ' + (e?.message || e));
            setSedang(false);
        }
    };

    return (
        <div style={{ marginTop: 18, padding: 12, border: '1px solid #fecaca', borderRadius: 8, background: '#fef2f2' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className="material-symbols-outlined" style={{ fontSize: 16, color: '#dc2626' }}>delete</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#991b1b' }}>Delete module</div>
                    <div style={{ fontSize: 9, color: '#b91c1c', marginTop: 2 }}>
                        {sebab || 'Removes this module, its master prompt and saved versions for every user. Cannot be undone.'}
                    </div>
                </div>
                {!sebab && !buka && (
                    <button
                        type="button"
                        onClick={() => { setBuka(true); setTaip(''); setRalat(''); }}
                        style={{ padding: '6px 12px', background: '#ffffff', border: '1px solid #fca5a5', borderRadius: 8, fontSize: 11, fontWeight: 700, color: '#dc2626', cursor: 'pointer', flex: 'none' }}
                    >
                        Delete…
                    </button>
                )}
            </div>

            {!sebab && buka && (
                <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 10, color: '#7f1d1d', lineHeight: 1.5, marginBottom: 6 }}>
                        Cards already using <b>{moduleLabel || moduleId}</b> will lose this formula (they fall back to AI8SAAT) — delete or move them first.
                        Type <b style={{ fontFamily: 'monospace' }}>{moduleId}</b> to confirm.
                    </div>
                    <input
                        value={taip}
                        onChange={(e) => setTaip(e.target.value)}
                        placeholder={moduleId}
                        autoFocus
                        style={{ width: '100%', padding: '8px 10px', fontSize: 12, fontFamily: 'monospace', border: '1px solid #fca5a5', borderRadius: 6, outline: 'none', boxSizing: 'border-box', background: '#ffffff' }}
                    />
                    {ralat && <div style={{ fontSize: 10, color: '#b91c1c', marginTop: 6, fontWeight: 600 }}>{ralat}</div>}
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                        <button
                            type="button"
                            disabled={sedang}
                            onClick={() => { setBuka(false); setTaip(''); setRalat(''); }}
                            style={{ padding: '6px 12px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 11, fontWeight: 600, color: '#64748b', cursor: 'pointer' }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            disabled={!padan || sedang}
                            onClick={jalan}
                            style={{
                                padding: '6px 12px', border: 'none', borderRadius: 8, fontSize: 11, fontWeight: 700, color: '#ffffff',
                                background: (!padan || sedang) ? '#fca5a5' : '#dc2626',
                                cursor: (!padan || sedang) ? 'not-allowed' : 'pointer',
                            }}
                        >
                            {sedang ? 'Deleting…' : 'Delete permanently'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
